import React from 'react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_06e7508c-1e62-492f-99e4-396c2a55bc67/artifacts/skihh497_Copia%20de%20HISTORIAS%20ORG%20RAM%20%28Tu%20historia%29%20%281%29.png";

const quickLinks = [
  { label: 'Inicio', href: '#inicio' },
  { label: 'Servicios', href: '#servicios' },
  { label: 'Nosotros', href: '#nosotros' },
  { label: 'Contacto', href: '#contacto' },
];

const services = [
  'Seguro de Auto',
  'Seguro del Hogar',
  'Asistencia al Viajero',
  'Seguros Empresariales',
  'Gestoría del Automotor',
];

const socialLinks = [
  { icon: 'fa-instagram', href: 'https://www.instagram.com/organizacionram.625/', label: 'Instagram' },
  { icon: 'fa-facebook-f', href: '#', label: 'Facebook' },
  { icon: 'fa-whatsapp', href: 'https://wa.me/5491161573380', label: 'WhatsApp' },
];

export const Footer = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[hsl(222_47%_11%)] text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-4 md:px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <img 
                src={LOGO_URL} 
                alt="Organizacion Ram" 
                className="h-14 w-auto"
              />
              <span className="font-bold text-xl">
                ORGANIZACIÓN <span className="text-primary">RAM</span>
              </span>
            </div>
            <p className="text-white/70 leading-relaxed mb-6">
              Tu tranquilidad es nuestra prioridad. Más de 10 años protegiendo lo que más te importa.
            </p>
            <div className="flex gap-3">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-primary transition-colors duration-300"
                  aria-label={social.label}
                >
                  <i className={`fab ${social.icon}`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-6">Enlaces Rápidos</h4>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); scrollToSection(link.href); }}
                    className="text-white/70 hover:text-white transition-colors duration-300 flex items-center gap-2"
                  >
                    <i className="fas fa-chevron-right text-xs text-primary"></i>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold text-lg mb-6">Nuestros Servicios</h4>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index}>
                  <span className="text-white/70 flex items-center gap-2">
                    <i className="fas fa-check text-xs text-primary"></i>
                    {service}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-lg mb-6">Contacto</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="fas fa-map-marker-alt text-primary mt-1"></i>
                <span className="text-white/70">
                  San Martin 625, Longchamps<br />
                  Buenos Aires, Argentina
                </span>
              </li>
              <li className="flex items-center gap-3">
                <i className="fas fa-phone-alt text-primary"></i>
                <a href="tel:+5491161573380" className="text-white/70 hover:text-white transition-colors">
                  +54 11 6157-3380
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="fas fa-envelope text-primary"></i>
                <a href="mailto:Organizacionram.asegurados@gmail.com" className="text-white/70 hover:text-white transition-colors">
                  Organizacionram.asegurados@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="fas fa-clock text-primary"></i>
                <span className="text-white/70">
                  Lun - Vie: 9:00 - 18:00
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="container mx-auto px-4 md:px-6 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-white/50 text-sm">
              © {new Date().getFullYear()} Organización RAM. Todos los derechos reservados.
            </p>
            <div className="flex items-center gap-6 text-sm text-white/50">
              <a href="#" className="hover:text-white transition-colors">Términos y Condiciones</a>
              <a href="#" className="hover:text-white transition-colors">Política de Privacidad</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
